import React from 'react';
import { iconWrapper, InjectedProps } from '../iconWrapper';

interface Props extends InjectedProps {
  className?: string;
}

class Email extends React.PureComponent<Props> {
  public render() {
    return (
      <svg
        className={['icon-svg', 'svg-email', this.props.className].join(' ')}
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 16 17"
      >
        <path d="M2.66667 5.42706V12.5367C2.66667 12.5411 2.66678 12.5412 2.66227 12.5412H13.3331H13.3377C13.3349 12.5412 13.3335 12.5411 13.3331 12.5412L13.3333 6.54122H14.6667V12.5443C14.6667 13.2733 14.0707 13.8746 13.3377 13.8746H2.66227C1.9264 13.8746 1.33334 13.2735 1.33334 12.5367V4.54578C1.33334 3.80843 1.92619 3.20789 2.66227 3.20789H13.3377C14.3236 3.20789 14.6714 4.16972 13.9417 4.81837L8.94415 9.26062C8.41948 9.72698 7.58902 9.73412 7.05925 9.27057L2.66667 5.42706ZM3.67906 4.54122L7.93726 8.26714C7.95931 8.28644 8.03389 8.2858 8.05833 8.26407L12.2465 4.54122H3.67906Z" />
      </svg>
    );
  }
}

export const icon = iconWrapper(Email);
